export const css = {
    root: 'yeIH93wr',
    splash: '_3QWeudO0',
    dynamicContainer: '_2tDP-fCM',
    progressBar: '_1Sy4wGk0',
    ' _key': 'apic-theme/apic/micro/lcc-app/splash'
};
export default css;
